// Where a payout's receipt came from (payout.documents.source): a reply to the tg
// gateway bot's Confirm prompt, or the cabinet's manual confirm. Written by core.
export const PAYOUT_DOCUMENT_SOURCE = ['telegram', 'cabinet'];
